import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

export const IncomingIcon: React.FC<IconProps> = (props) => (
    <Icon viewBox="0 0 24 24" {...props}>
        {/* Phone shape */}
        <path
            d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.21c1.21.49 2.53.76 3.88.76a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.35.27 2.67.76 3.88a1 1 0 01-.21 1.11l-2.2 2.2z"
            fill="#22c55e"
        />
        {/* Incoming arrow */}
        <path
            d="M15 3v5m0 0l-2-2m2 2l2-2"
            stroke="#22c55e"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        />
    </Icon>
);
